import { ReactComponent as AffinityLogo } from '../assets/logos/dark/new-affinity.svg';
import { ReactComponent as AssistCardLogo } from '../assets/logos/dark/assist-dark.svg';
import { ReactComponent as UniversalAssistance } from '../assets/logos/dark/logo-universal-dark.svg';
import { ReactComponent as AffinityLogoLight } from '../assets/logos/light/affinity-light.svg';
import { ReactComponent as AssistCardLogoLight } from '../assets/logos/light/assist-light.svg';
import { ReactComponent as UniversalAssistanceLight } from '../assets/logos/light/universal-light.svg';

const logos = [
  {
    id: 2,
    name: 'affinity',
    component: { dark: <AffinityLogo />, light: <AffinityLogoLight /> },
    websiteUrl: 'https://www.affinityseguroviagem.com.br/',
  },
  {
    id: 3,
    name: 'assist-card',
    component: { dark: <AssistCardLogo />, light: <AssistCardLogoLight /> },
    websiteUrl: 'https://www.assistcard.com/',
  },
  {
    id: 4,
    name: 'universal-assistance',
    component: {
      dark: <UniversalAssistance />,
      light: <UniversalAssistanceLight />,
    },
    websiteUrl: 'https://www.universal-assistance.com/',
  },
];

const getPartnerLogo = (insuranceCompany) => {
  return logos.find((logo) => logo.name === insuranceCompany);
};

const getAllPartnersLogos = () => {
  return logos;
};

export { getPartnerLogo, getAllPartnersLogos };
